/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetApplicationProgress_creditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type GetApplicationProgress_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly savedSectionsInfo: ReadonlyArray<GetApplicationProgress_creditApplication_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export type GetApplicationProgress_Query = { readonly __typename: 'Query', readonly creditApplication: GetApplicationProgress_creditApplication_CreditApplication | null };


export type GetApplicationProgressVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetApplicationProgress = GetApplicationProgress_Query;


export const GetApplicationProgressDocument = gql`
    query GetApplicationProgress($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    savedSectionsInfo {
      sectionName
      completedAt
      completionStatus
    }
  }
}
    `;

/**
 * __useGetApplicationProgress__
 *
 * To run a query within a React component, call `useGetApplicationProgress` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationProgress` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationProgress({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetApplicationProgress(baseOptions: Apollo.QueryHookOptions<GetApplicationProgress, GetApplicationProgressVariables> & ({ variables: GetApplicationProgressVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationProgress, GetApplicationProgressVariables>(GetApplicationProgressDocument, options);
      }
export function useGetApplicationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationProgress, GetApplicationProgressVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationProgress, GetApplicationProgressVariables>(GetApplicationProgressDocument, options);
        }
export function useGetApplicationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationProgress, GetApplicationProgressVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationProgress, GetApplicationProgressVariables>(GetApplicationProgressDocument, options);
        }
export type GetApplicationProgressHookResult = ReturnType<typeof useGetApplicationProgress>;
export type GetApplicationProgressLazyQueryHookResult = ReturnType<typeof useGetApplicationProgressLazyQuery>;
export type GetApplicationProgressSuspenseQueryHookResult = ReturnType<typeof useGetApplicationProgressSuspenseQuery>;
export type GetApplicationProgressQueryResult = Apollo.QueryResult<GetApplicationProgress, GetApplicationProgressVariables>;